import { render, staticRenderFns } from "./ClubServiceCard.vue?vue&type=template&id=95ccbea6&scoped=true&"
import script from "./ClubServiceCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClubServiceCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ClubServiceCard.vue?vue&type=style&index=0&id=95ccbea6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ccbea6",
  null
  
)

export default component.exports